import type { RutaProd } from '../../../../runtime/rutas';
export default {
  ruta: '/sistema/pos/tools/inventory',
  documento: 'pos-tools',
  acceso: 'sesion',
  filas: ['040'],
  cita: 'Areas/POS_Tools/Controllers/InventoryController.cs:16',
} satisfies RutaProd;
